export const HAS_CLOSED_CHANGE_HOMEPAGE_MODAL = 'HAS_CLOSED_CHANGE_HOMEPAGE_MODAL';